import { apiFetch } from '@libs/core';

import { getNextApiRoute } from '../../utils/api'; // NOSONAR - deprecated function is still required for existing API routes
import type { AddSubscriptionResponse, PostOrdergrooveAddSubscription } from './types';

export async function addAutoshipSubscription(body: PostOrdergrooveAddSubscription): Promise<AddSubscriptionResponse> {
    const url = getNextApiRoute('ordergroove'); // NOSONAR - deprecated function is still required for existing API routes
    const response = await apiFetch<AddSubscriptionResponse>(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (response instanceof Error) {
        throw new Error(response.message);
    }

    // apiFetch returns Response for non-2xx status codes
    if (response instanceof Response) {
        throw new Error('Failed to add autoship subscription. non-2xx status code.');
    }

    return response;
}
